import './LandingPage.css';
import Header from './landing/Header';
import HeroSection from './landing/HeroSection';
import ChatServeSection from './landing/ChatServeSection';
import ServicesSection from './landing/ServicesSection';
import TaglineSection from './landing/TaglineSection';
import AboutSection from './landing/AboutSection';
import ProcessSection from './landing/ProcessSection';
import FaqSection from './landing/FaqSection';
import ContactSection from './landing/ContactSection';
import Footer from './landing/Footer';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { usePageMeta } from '../hooks/usePageMeta';

// Scrolling (top on arrival, #hash targets, back/forward positions) is handled
// once for every route by <ScrollRestoration /> in App.tsx.
function LandingPage() {
  useScrollReveal();
  usePageMeta(
    'EFSoft | Custom web applications and the team behind ChatServe',
    'EFSoft builds web applications for businesses and runs ChatServe, its own ordering and fiscal receipt system for restaurants in Romania and Spain. More than 20 years of software engineering.',
    '/'
  );

  return (
    <div className="site">
      <Header />
      <main id="main-content" tabIndex={-1}>
        <HeroSection />
        <ChatServeSection />
        <ServicesSection />
        <TaglineSection />
        <AboutSection />
        <ProcessSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
